import { useSelector } from 'react-redux';
import classes from './Account.module.css'
import { RootState } from '../../Store/store';
import Progres from '../../Components/Progres/Progres';
import Button2 from '../../Components/UI/Button2/Button2';
import Button1 from '../../Components/UI/Button1/Button1';
import { Preview, print } from 'react-html2pdf';
import serf from './../../assets/img/serf.png'
import generatePDF,{ Margin, Resolution } from 'react-to-pdf';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import FullSpaseLoader from '../../Components/UI/Loader/FullSpaseLoader';



const Account = () => {

    
    const getTargetElement = () => document.getElementById('content-id');
    const user = useSelector((state:RootState)=>state.user.user)
    const maxActiveLessonId = useSelector((state:RootState)=>state.user.maxActiveLessonId)
    const lessons = useSelector((state:RootState)=>state.user.lessons)

    const [isLoading, setIsLoading] = useState(false)

    const nav = useNavigate()
    return ( 
        <div className={classes.account}> 
        <FullSpaseLoader isLoader={isLoading} />
            <div className={classes.container}>
                <div className={classes.title}>
                    Личный кабинет
                </div>
                
                <div className={classes.data}>
                    <div className={classes.progres}>
                        <Progres />
                    </div>
                    
                    <div className={classes.textData}>
                        <div className={classes.fullName}>
                                {user?.full_name}
                            </div>
                            <div className={classes.text}>
                                Дата: {user?.birthday.split('-').reverse().join('.')}
                            </div>
                            <div className={classes.text}>
                                Статус: {user?.status}
                            </div>
                            <div className={classes.text}>
                                Наименование организации: {user?.organization}
                            </div>
                            <div className={classes.text}>
                                Профиль обучения: {user?.education}
                            </div>
                            <div className={classes.text}>
                                E-mail: {user?.email}
                            </div>
                            <div className={classes.text}>
                                Телефон: {user?.phone }
                            </div>
                    </div>
                </div>

                <div className={classes.buttons}>
                        <Button2 onClick={()=>nav('/edit')}>Редактировать профиль</Button2>
                        <Button1 onClick={()=>nav('/education')}>Продолжить обучение</Button1>
                </div>

                {
                    maxActiveLessonId>=lessons.length
                    ?
                    <button className={classes.link} onClick={ async () => {
                        setIsLoading(true)
                        await generatePDF(getTargetElement,{
                            resolution: Resolution.HIGH,
                            page: { 
                                margin:{
                                    left:0,
                                    right:0,
                                    top:0,
                                    bottom:-2
                                }, 
                                // default is 'A4'
                                format: [210,148],
                                // default is 'portrait'
                                orientation: 'landscape',
                            },
                            filename:"Сертификат #ЗАОДНОДОБРО"
                        })
                        setIsLoading(false)
                        }}>
                        Скачать сертификат
                    </button>
                    :
                    <></>
                } 
                
                <button className={classes.linkRed} onClick={()=>{
                    localStorage.removeItem("token")
                    window.location.reload()
                }}>
                    Выйти из аккаунта
                </button>

                <div style={{opacity:0, maxHeight:'0',overflow:'hidden'}}>
                    <div id='content-id' className={classes.pdf}>
                        <img src={serf}/> 
                        <div className={classes.pdfText}>
                            {user?.full_name}
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
     );
}
 
export default Account;